import React from 'react';

type Props = {
  children: React.ReactNode;
  danger?: React.ReactNode;
  className?: string;
};

/** Single-line action buttons for table rows — never wraps; table scrolls horizontally instead. */
export default function TableActionBar({ children, danger, className = '' }: Props) {
  const classes = ['table-action-bar', className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {children}
      {danger}
    </div>
  );
}
